import type { Money, Uuid } from '@shared/api';
import type { MediaLink } from '@entities/media';

export type RfqDispatch = 'PUBLIC' | 'TARGETED';

// §7 v1.2 — RFQ lifecycle status.
export type RfqStatus = 'OPEN' | 'CLOSED' | 'EXPIRED';

export interface BuyRequest {
  id: Uuid;
  buyerId: Uuid;
  name: string;
  category: Uuid;
  hsCode: string | null;
  volumeText: string | null;
  budget: Money | null;
  deadline: string | null;
  destinationCountry: string | null;
  techDescription: string | null;
  attachments: MediaLink[];
  dispatch: RfqDispatch;
  targetManufacturer: Uuid | null;
  status: RfqStatus;
  hiddenByAdmin: boolean;
  hiddenReason: string | null;
  quoteCount: number;
  createdAt: string;
  updatedAt: string;
  // Hint set by feed-list when the producer already responded.
  alreadyQuoted?: boolean;
}

export interface QuoteAttachment {
  mediaId: Uuid;
}

export interface Quote {
  id: Uuid;
  buyRequestId: Uuid;
  buyRequestTitle?: string;
  manufacturerId: Uuid;
  priceTotal: Money;
  leadTimeDays: number;
  terms: string | null;
  attachments: MediaLink[];
  acceptedAt?: string | null;
  withdrawn: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface SubmitQuoteRequest {
  priceAmount: string;
  priceCurrency: string;
  leadTimeDays: number;
  terms?: string | null;
  attachments: Uuid[];
}

export interface BuyRequestFeedQuery {
  category?: Uuid;
  country?: string;
  q?: string;
  page?: number;
  size?: number;
}

export type QuoteStatus = 'ACTIVE' | 'WITHDRAWN' | 'ACCEPTED';

export function quoteStatus(q: Quote): QuoteStatus {
  if (q.acceptedAt) return 'ACCEPTED';
  if (q.withdrawn) return 'WITHDRAWN';
  return 'ACTIVE';
}

// Convenience: can the producer still submit a quote against this RFQ?
export function canSubmitAgainst(rfq: BuyRequest): boolean {
  return rfq.status === 'OPEN' && !rfq.hiddenByAdmin && !rfq.alreadyQuoted;
}
